import { streamGroq, GroqMissingKeyError } from './groq-client';

export async function aiSuggestClauses(scopeSummary: string, jurisdiction: string, onStream: (chunk: string) => void): Promise<void> {
  const system = `You are a contracts lawyer reviewing a freelance/consulting contract. Given the scope and jurisdiction, suggest: 1) 3 protective clauses to ADD, 2) 2 standard clauses to STRENGTHEN, 3) 1 risk specific to this jurisdiction. Output as Markdown checklist. Never give legal advice — flag risks for attorney review.`;
  try {
    await streamGroq({
      messages: [{ role: 'system', content: system }, { role: 'user', content: `Scope: ${scopeSummary}\nJurisdiction: ${jurisdiction}` }],
      temperature: 0.3, onStream,
    });
  } catch (err) {
    if (err instanceof GroqMissingKeyError) { onStream('\n\n⚠️ No Groq API key set. Click the Settings gear ⚙ to add your free key.'); return; }
    onStream(`\n\n⚠️ ${err instanceof Error ? err.message : 'Groq error'}`);
  }
}
